import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedReorder202510: FaireAdPerformancePeriodEntity =
  {
    token: "perf_p4_under_utilized_reorder_202510",
    type: "adPerformancePeriod",
    scope: "REORDER_MARKETPLACE",
    periodType: "RECEIPT",
    startDate: "2025-10-01",
    endDate: "2025-10-31",
    impressions: 5535,
    clicks: 98,
    adsSpendDollars: 300,
    budgetDollars: 500,
    salesDollars: 12162,
    bestEstimateRoas: 40.54,
    bestEstimateType: "ACTUALIZED",
    budgetUtilization: 0.6,
    reorderConversions: 15,
    dataAvailableAtDate: "2025-11-04",
    meta: {
      source: "mock",
      importedAt: "2026-07-06T00:00:00.000Z",
      importedBy: "advertiser-profiles",
    },
  };
